import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
} from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import type { CSSProperties, Ref } from 'vue'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons'

import { DisciplineScheduleFlow } from './enums'
import { useDisciplineScheduleStore } from './schedule/store'

interface DisciplineWeeklyScheduleActionsReturn {
  isOpen: Ref<boolean>
  containerRef: Ref<HTMLElement | null>
  floatingRef: Ref<HTMLElement | null>
  floatingStyles: Ref<CSSProperties>
  triggerIcon: IconDefinition
  toggle: () => void
  openChange: () => void
  openSetupLessons: () => void
}

export const useDisciplineWeeklyScheduleActions = (): DisciplineWeeklyScheduleActionsReturn => {
  const store = useDisciplineScheduleStore()

  const isOpen = ref(false)
  const containerRef = ref<HTMLElement | null>(null)
  const floatingRef = ref<HTMLElement | null>(null)

  const { floatingStyles } = useFloating(containerRef, floatingRef, {
    placement: 'bottom-end',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(4),
      flip(),
      shift({ padding: 8 }),
    ],
  })

  const toggle = (): void => {
    isOpen.value = !isOpen.value
  }

  const open = (flow: DisciplineScheduleFlow): void => {
    isOpen.value = false
    store.openFlow(flow)
  }

  onClickOutside(containerRef, () => {
    isOpen.value = false
  })

  return {
    isOpen,
    containerRef,
    floatingRef,
    floatingStyles,
    triggerIcon: faEllipsisVertical,
    toggle,
    openChange: () => open(DisciplineScheduleFlow.Change),
    openSetupLessons: () => open(DisciplineScheduleFlow.SetupLessons),
  }
}
